import React from 'react';

import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '../ui/tooltip';
import { Button } from '../ui/button';
import { Suggestion } from './types';

interface SuggestionsProps {
  suggestions: Suggestion[];
  onQuestionClick: (suggestion: Suggestion) => void;
  title?: string;
}

export function Suggestions({ suggestions, onQuestionClick, title = 'Suggested questions' }: SuggestionsProps) {
  if (!suggestions || suggestions.length === 0) return null;

  return (
    <div className="w-full p-3 md:p-0" data-name="Suggestions">
      <h3 className="text-base font-medium mb-4 text-foreground">{title}</h3>
      <div className="flex flex-wrap gap-2">
        {suggestions.map((suggestion) => (
          <Button
            key={suggestion.id}
            onClick={() => onQuestionClick(suggestion)}
            variant="outline"
            className="border-border font-normal whitespace-normal h-auto text-left"
          >
            {suggestion.messageCount !== undefined && (
              <TooltipProvider>
                <Tooltip>
                  <TooltipTrigger asChild>
                    <span className="bg-gray-100 text-gray-600 px-2 py-0.5 rounded-full text-xs min-w-[20px] border flex items-center justify-center border-border">
                      {suggestion.messageCount}
                    </span>
                  </TooltipTrigger>
                  <TooltipContent>
                    <p>{suggestion.messageCount} messages in this conversation</p>
                  </TooltipContent>
                </Tooltip>
              </TooltipProvider>
            )}
            <span className="">{suggestion.question}</span>
          </Button>
        ))}
      </div>
    </div>
  );
}

export default Suggestions;
